import { render } from "./MoatCompsBody.vue?vue&type=template&id=4ea76dd8"
import script from "./MoatCompsBody.vue?vue&type=script&lang=js"
export * from "./MoatCompsBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__